import getYear from "date-fns/getYear";
import isValid from "date-fns/isValid";
import parseDateYmd from "lib/utils/parseDateYmd";
import type { IntlShape } from "react-intl";

export default function formatDateOrReturnHyphen(intl: IntlShape, value: string | undefined) {
  if (!value) {
    return "-";
  }

  const date = parseDateYmd(value);

  if (getYear(date) === 1900 || !isValid(date)) {
    return "-";
  }

  return intl.formatDate(date, {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  });
}
